/**
 * Records events with a dynamic data-dxa string.
 * @param {String} dataDxaString the end state of the data-dxa string
 */
export function recordDynamicEvent(dataDxaString) {
  document.dispatchEvent(
    new CustomEvent('data-dxa-dynamic-event', { detail: { dataDxaString } }),
  )
}
